export default __webpack_public_path__ + "static/media/male-avatar.d28a9dc8.svg";